module.exports = __webpack_public_path__ + "images/c38510b.png";